<ng-container>
  <app-h *ngIf="showHeadline" [subtitle]="headline" type="h2"></app-h>
  <div class="external-html" [innerHTML]="content"></div>
</ng-container>
